// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const svnr: CountryValidator<"DE"> = createValidator(
  "de.svnr",
  54,
);

export default svnr;
export const compact = svnr.compact;
export const format = svnr.format;
export const validate = svnr.validate;
export const generate = (): string =>
  svnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator de.svnr cannot generate values",
    );
  })();
